import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateMilestone = createAsyncThunk(
  "initiatives/updateMilestone",
  async ({ milestoneId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/milestones/${milestoneId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data || !response.data.success) {
        return rejectWithValue(response.data?.message || "Failed to update milestone");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update milestone");
    }
  }
);
